var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 87,
    viewBox: "0 0 95 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.7572 26.0844C75.911 24.9981 75.9883 23.9024 75.9883 22.8051C75.976 12.039 68.5375 2.77203 58.2014 0.644548C47.8652 -1.48294 37.492 4.118 33.3951 14.0378C28.3356 10.5052 21.6317 10.6678 16.7416 14.4412C11.8522 18.2155 9.86988 24.7566 11.8182 30.6899C4.62256 33.696 -0.0565029 40.871 0.00225607 48.8078C0.0602418 56.7455 4.84368 63.8479 12.0826 66.7435C12.8975 67.0671 13.8152 66.6558 14.133 65.8238C14.4508 64.991 14.0472 64.0539 13.2323 63.7295C6.95204 61.2183 2.91546 54.9243 3.17292 48.0429C3.43115 41.1607 7.92543 35.199 14.375 33.1852C14.8172 33.0463 15.1783 32.7171 15.3623 32.2845C15.5471 31.8511 15.537 31.3577 15.3345 30.933C14.6085 29.4078 14.2327 27.7343 14.2358 26.0386C14.2397 21.4971 16.9001 17.3976 20.9946 15.623C25.0884 13.8484 29.8255 14.742 33.0278 17.8942C33.426 18.2833 33.9935 18.4333 34.527 18.2905C35.0604 18.1468 35.4818 17.73 35.6403 17.1908C38.6254 7.16752 48.8657 1.37476 58.7712 4.10536C68.6767 6.83518 74.6709 17.1032 72.3105 27.2985C72.193 27.8014 72.319 28.3319 72.6491 28.7242C72.9769 29.1205 73.4733 29.3289 73.9789 29.2823C74.125 29.2721 74.2549 29.2721 74.4049 29.2721C82.6095 29.265 89.7062 35.1043 91.4435 43.2914C93.1799 51.4785 89.0861 59.7934 81.6145 63.2526C81.0864 63.4839 80.7223 63.9884 80.6628 64.571C80.6032 65.1544 80.8568 65.7243 81.3269 66.0614C81.7962 66.3985 82.4085 66.4498 82.925 66.1956C91.5215 62.2114 96.3614 52.7668 94.6675 43.2843C92.9727 33.8018 85.1779 26.712 75.7572 26.0844Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9868 35.739H18.9845C18.1101 35.739 17.4011 36.4629 17.4011 37.3557V53.5231C17.4011 54.4159 18.1101 55.1398 18.9845 55.1398H75.9868C76.8613 55.1398 77.5702 54.4159 77.5702 53.5231V37.3557C77.5702 36.4629 76.8613 35.739 75.9868 35.739ZM74.4035 51.9063H20.5679V38.9725H74.4035V51.9063Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0698 40.5892H71.2366V43.8227H68.0698V40.5892Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7363 40.5892H64.9031V43.8227H61.7363V40.5892Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4028 40.5892H58.5696V43.8227H55.4028V40.5892Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0691 40.5892H52.2359V43.8227H49.0691V40.5892Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7356 40.5892H45.9024V43.8227H42.7356V40.5892Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0698 47.0562H71.2366V50.2897H68.0698V47.0562Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7363 47.0562H64.9031V50.2897H61.7363V47.0562Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4028 47.0562H58.5696V50.2897H55.4028V47.0562Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0691 47.0562H52.2359V50.2897H49.0691V47.0562Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7356 47.0562H45.9024V50.2897H42.7356V47.0562Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4019 40.5892H39.5687V43.8227H36.4019V40.5892Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4019 47.0562H39.5687V50.2897H36.4019V47.0562Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4851 50.2896C31.1083 50.2896 33.2352 48.1187 33.2352 45.4394C33.2352 42.7609 31.1083 40.5892 28.4851 40.5892C25.8618 40.5892 23.7349 42.7609 23.7349 45.4394C23.7349 48.1187 25.8618 50.2896 28.4851 50.2896ZM28.4851 43.8227C29.3595 43.8227 30.0685 44.5466 30.0685 45.4394C30.0685 46.3322 29.3595 47.0561 28.4851 47.0561C27.6106 47.0561 26.9017 46.3322 26.9017 45.4394C26.9017 44.5466 27.6106 43.8227 28.4851 43.8227Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9868 56.7565H18.9845C18.1101 56.7565 17.4011 57.4804 17.4011 58.3733V74.5406C17.4011 75.4334 18.1101 76.1573 18.9845 76.1573H75.9868C76.8613 76.1573 77.5702 75.4334 77.5702 74.5406V58.3733C77.5702 57.4804 76.8613 56.7565 75.9868 56.7565ZM74.4035 72.9239H20.5679V59.99H74.4035V72.9239Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0698 61.6068H71.2366V64.8402H68.0698V61.6068Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7363 61.6068H64.9031V64.8402H61.7363V61.6068Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4028 61.6068H58.5696V64.8402H55.4028V61.6068Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0691 61.6068H52.2359V64.8402H49.0691V61.6068Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7356 61.6068H45.9024V64.8402H42.7356V61.6068Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0698 68.0737H71.2366V71.3071H68.0698V68.0737Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7363 68.0737H64.9031V71.3071H61.7363V68.0737Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4028 68.0737H58.5696V71.3071H55.4028V68.0737Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0691 68.0737H52.2359V71.3071H49.0691V68.0737Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7356 68.0737H45.9024V71.3071H42.7356V68.0737Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4019 61.6068H39.5687V64.8402H36.4019V61.6068Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4019 68.0737H39.5687V71.3071H36.4019V68.0737Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4851 71.3071C31.1083 71.3071 33.2352 69.1362 33.2352 66.4569C33.2352 63.7784 31.1083 61.6068 28.4851 61.6068C25.8618 61.6068 23.7349 63.7784 23.7349 66.4569C23.7349 69.1362 25.8618 71.3071 28.4851 71.3071ZM28.4851 64.8402C29.3595 64.8402 30.0685 65.5641 30.0685 66.4569C30.0685 67.3498 29.3595 68.0737 28.4851 68.0737C27.6106 68.0737 26.9017 67.3498 26.9017 66.4569C26.9017 65.5641 27.6106 64.8402 28.4851 64.8402Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9868 77.7741H18.9845C18.1101 77.7741 17.4011 78.498 17.4011 79.3908V95.5581C17.4011 96.4509 18.1101 97.1748 18.9845 97.1748H75.9868C76.8613 97.1748 77.5702 96.4509 77.5702 95.5581V79.3908C77.5702 78.498 76.8613 77.7741 75.9868 77.7741ZM74.4035 93.9414H20.5679V81.0075H74.4035V93.9414Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0698 82.6243H71.2366V85.8577H68.0698V82.6243Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7363 82.6243H64.9031V85.8577H61.7363V82.6243Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4028 82.6243H58.5696V85.8577H55.4028V82.6243Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0691 82.6243H52.2359V85.8577H49.0691V82.6243Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7356 82.6243H45.9024V85.8577H42.7356V82.6243Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0698 89.0912H71.2366V92.3246H68.0698V89.0912Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7363 89.0912H64.9031V92.3246H61.7363V89.0912Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4028 89.0912H58.5696V92.3246H55.4028V89.0912Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0691 89.0912H52.2359V92.3246H49.0691V89.0912Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7356 89.0912H45.9024V92.3246H42.7356V89.0912Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4019 82.6243H39.5687V85.8577H36.4019V82.6243Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4019 89.0912H39.5687V92.3246H36.4019V89.0912Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4851 92.3247C31.1083 92.3247 33.2352 90.1538 33.2352 87.4745C33.2352 84.796 31.1083 82.6243 28.4851 82.6243C25.8618 82.6243 23.7349 84.796 23.7349 87.4745C23.7349 90.1538 25.8618 92.3247 28.4851 92.3247ZM28.4851 85.8577C29.3595 85.8577 30.0685 86.5816 30.0685 87.4745C30.0685 88.3673 29.3595 89.0912 28.4851 89.0912C27.6106 89.0912 26.9017 88.3673 26.9017 87.4745C26.9017 86.5816 27.6106 85.8577 28.4851 85.8577Z",
    fill: "#FFFFFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 95,
    height: 97,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.c09e91a895b069611b8754a9c3b960fa.svg";
export { ForwardRef as ReactComponent };